import React from "react";

interface PredictionTargetPreviewProps {
  prediction: {
    optionA: { url: string; label: string };
    optionB: { url: string; label: string };
  };
}

const PredictionTargetPreview = ({ prediction }: PredictionTargetPreviewProps) => {
  const { optionA, optionB } = prediction;

  return (
    <div className="relative rounded-lg overflow-hidden border border-border/50 bg-muted/30 p-3">
      <div className="grid grid-cols-2 gap-2">
        {/* Option A - Yes */}
        <div className="relative rounded-md overflow-hidden border border-border/30">
          <div className="aspect-[3/2]">
            <img
              src={optionA.url}
              alt={`Option ${optionA.label}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute bottom-1 left-1 bg-emerald-500/90 backdrop-blur-sm text-xs px-1.5 py-0.5 rounded font-medium text-white">
            {optionA.label}
          </div>
        </div>

        {/* Option B - No */}
        <div className="relative rounded-md overflow-hidden border border-border/30">
          <div className="aspect-[3/2]">
            <img
              src={optionB.url}
              alt={`Option ${optionB.label}`}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute bottom-1 left-1 bg-rose-500/90 backdrop-blur-sm text-xs px-1.5 py-0.5 rounded font-medium text-white">
            {optionB.label}
          </div>
        </div>
      </div>
      <div className="absolute top-2 right-2 bg-background/80 backdrop-blur-sm text-xs px-2 py-1 rounded text-muted-foreground">
        Awaiting Result
      </div>
    </div>
  );
};

export default PredictionTargetPreview;
